<template>
  <div class="row align-items-baseline">
    <div class="col-12">
      <FormLabel label-is-fake :hide-label="hideLabel">{{ label }}</FormLabel>
    </div>

    <div v-if="cleanedTotal === 0" class="col-12">
      <AlertFeedback status="warning">
        Totale non specificato
      </AlertFeedback>
    </div>
    <AwlTable v-else class="col-12" :heading="headings" :rows="valuesCleaned" hide-header>
      <template #column-key-month="{ value }">
        {{ value }}
      </template>

      <template #column-key-hours="{ row, value, rowNumber }">
        <FormInputText type="number" :min="1" :step="1" :value="value" @input="updateHoursInMonth(rowNumber, $event)" />
      </template>
    </AwlTable>
  </div>
</template>

<script>

import { yearMonthsBetween } from '@/helpers/months';

export default {
  name: 'form-input-project-piano-fatturazione-widget',
  components: {
    FormLabel: () => import('@/libs/Form/components/FormLabel'),
    AwlTable: () => import('@/libs/Table/components/AwlTable'),
    FormInputText: () => import('@/libs/Form/components/Inputs/FormInputText'),
    AlertFeedback: () => import('@/libs/Feedback/components/Alert'),
  },
  props: {
    label: {
      type: String,
      default: 'Ore mensili',
    },
    hideLabel: {
      type: Boolean,
      default: true,
    },
    total: {
      default: 0,
    },
    value: {
      type: Array,
      default: () => [],
    },
    firstMonth: {},
    lastMonth: {},
  },
  computed: {
    cleanedTotal () {
      return parseInt(this.total || 0);
    },
    valueTotal () {
      return this.value.reduce((h, v) => h + v.hours, 0);
    },
    totalRemaining () {
      return this.cleanedTotal - this.valueTotal;
    },
    headings () {
      return [
        { key: 'month', label: 'Mese' },
        { key: 'hours', label: 'Ore' },
      ];
    },
    months () {
      return yearMonthsBetween(this.firstMonth, this.lastMonth);
    },
    valuesCleaned () {
      const values = (this.value || []);
      this.months.forEach(m => {
        values.push({
          month: m,
          hours: 0,
        });
      });

      return values.filter((value, index, self) => self.findIndex(v => v.month === value.month) === index).sort((a, b) => {
        if (a.month === b.month) {
          return 0;
        }

        if (!a.month) {
          return 1;
        }

        if (!b.month) {
          return -1;
        }

        return a.month < b.month ? -1 : 1;
      });
    },
  },
  methods: {
    emitValue (newValue) {
      this.$emit('input', newValue.filter((value, index, self) => self.findIndex(v => v.month === value.month) === index).sort((a, b) => {
        if (a.month === b.month) {
          return 0;
        }

        if (!a.month) {
          return 1;
        }

        if (!b.month) {
          return -1;
        }

        return a.month < b.month ? -1 : 1;
      }));
    },
    updateHoursInMonth (rowNumber, value) {
      this.emitValue((this.value || []).map((r, i) => {
        if (i === rowNumber) {
          r.hours = parseInt(value) || 0;
        }

        return r;
      }));
    },
  },
};

</script>
